
export default {
  head() {
    return {
      title:
        "Agence Google Ads | SEA dans les DOM-TOM dès 290€/mois - ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads dans les DOM-TOM certifiée Google Partner, accompagne les entreprises ultramarines pour accroître leur visibilité en ligne et attirer des prospects qualifiés.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Agence Google Ads dans les DOM-TOM dès 290€/mois - ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads dans les DOM-TOM certifiée Google Partner, accompagne les entreprises ultramarines pour accroître leur visibilité en ligne et attirer des prospects qualifiés.",
        },
      ],
    };
  },
};
